import httpbaseURL from "../common/axios";
class Commonservices {
  ChangePassword(ObjaVAl) {
    return httpbaseURL.httpMSMOPCRMUrl.post(
      "/Password/ChangePassword",
      ObjaVAl
    );
  }
  GetUserMailId(EmailId) {
    return httpbaseURL.httpMSMOPCRMUrl.get(
      "/Password/GetUserMailId?EmailId=" + EmailId + ""
    );
  }
  GetUserById(UserId) {
    debugger;
    return httpbaseURL.httpMSMOPCRMUrl.get(
      "/Password/GetUserById?id=" + UserId + ""
    );
  }

  ForgotPasswordSendMail(UserObj) {
    debugger;
    return httpbaseURL.httpMSMOPCRMUrl.post(
      "/Password/ForgotPasswordSendMail",
      UserObj
    );
  }
}
export default new Commonservices();
